import { render, staticRenderFns } from "./select-audit-logs-event-types.vue?vue&type=template&id=87b117c0&scoped=true&"
import script from "./select-audit-logs-event-types.vue?vue&type=script&lang=js&"
export * from "./select-audit-logs-event-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b117c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87b117c0')) {
      api.createRecord('87b117c0', component.options)
    } else {
      api.reload('87b117c0', component.options)
    }
    module.hot.accept("./select-audit-logs-event-types.vue?vue&type=template&id=87b117c0&scoped=true&", function () {
      api.rerender('87b117c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audit_logs/partials/select-audit-logs-event-types.vue"
export default component.exports